
import Vue, { PropType } from "vue";
import { mapMutations, mapState, mapGetters } from "vuex";
// components
import VButton from "@/components/common/button.vue";
import AreaView from "@/views/top-area-view.vue";
import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";

export default Vue.extend({
  name: "component-filter-search-bar",
  components: { VButton, AreaView },
  props: {
    tmpArea: {
      type: Object as PropType<PortalAdapterApi.TopArea>,
      required: false,
      default() {
        return {} as PortalAdapterApi.TopArea;
      },
    },
  },
  data() {
    return {
      showAreaView: false,
      previousSelectedCountry: "jp",
    };
  },
  computed: {
    ...mapState("data", ["selectedTopPlace", "selectedCountry"]),
    ...mapGetters("ui", ["isMobile"]),
    showTopArea(): string {
      console.log(`----- show tmp top area ======`);
      console.log(this.tmpArea);
      return this.tmpArea === undefined ? "" : this.tmpArea.areaName === "Default" ? "" : this.tmpArea.displayText;
    },
  },
  created() {
    this.previousSelectedCountry = this.selectedCountry;
  },
  methods: {
    ...mapMutations("data", ["setSelectedCountry"]),
    ...mapMutations("ui", ["setShowFacility"]),
    searchClicked() {
      this.showAreaView = true;
      if (this.isMobile) {
        this.setShowFacility(true);
      }
    },
    closeAreaView(reallySelected: boolean) {
      this.setShowFacility(false);
      this.showAreaView = false;
      if (!reallySelected) {
        this.setSelectedCountry(this.previousSelectedCountry);
      }
    },
    topAreaSelected(area: PortalAdapterApi.TopArea) {
      this.previousSelectedCountry = this.selectedCountry;
      this.showAreaView = false;
      this.$emit("tmp-selected-top-place", area);
    },
  },
});
